/**
 * Warm the dashboard code chunks before they are needed.
 *
 * The developer dashboard is the app's largest chunk, and it only started
 * downloading once the visitor was already on /dashboard, behind a loader.
 * These are the same dynamic imports the lazy routes use, so webpack serves
 * the same chunks: calling them early only moves the download forward.
 */
let started = false;

export const preloadDashboards = () => {
  if (started) return;
  started = true;
  const load = [
    () => import('../components/Navigation/MainNavigation/Dashboard/DashboardRouter'),
    () => import('../components/Navigation/MainNavigation/Dashboard/Dashboard'),
    () => import('../components/Navigation/MainNavigation/LiteDashboard/LiteDashboard'),
  ];
  load.forEach((fn) => fn().catch(() => {
    // A failed prefetch is harmless: the route's own lazy import retries.
  }));
};

/** Preload once the browser is idle (signed-in visitors only). */
export const preloadDashboardsWhenIdle = () => {
  if (typeof window === 'undefined' || started) return;
  const saveData = typeof navigator !== 'undefined' && navigator.connection && navigator.connection.saveData;
  if (saveData) return;
  const run = () => preloadDashboards();
  if (typeof window.requestIdleCallback === 'function') {
    window.requestIdleCallback(run, { timeout: 5000 });
  } else {
    window.setTimeout(run, 2500);
  }
};
